import { Flex } from '@chakra-ui/layout';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

function PagesWithoutTabs({
    isNavBarExpanded,
    t,
    children,
    isBannerShown,
}: any) {
    const currentColors = useCurrentColors();
    const topPosition = isNavBarExpanded ? 130 : 70;
    return (
        <Flex
            minHeight={
                isNavBarExpanded ? 'calc(100vh - 130px)' : 'calc(100vh - 70px)'
            }
            top={isBannerShown ? topPosition + 75 : '70px'}
            position="relative"
            overflow="visible"
            p="4px"
            flexGrow={1}>
            {React.cloneElement(children, { t })}
        </Flex>
    );
}

PagesWithoutTabs.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('translations')(PagesWithoutTabs);
